<template>
  <div class="community-member-picker">
    <h2>Okay, first, which community member’s hunger story would you like to experience?</h2>
    <carousel :per-page="4" :navigationEnabled="true" :paginationEnabled="false">
    <slide v-for="member in members" :key="member.id">
      <div class="community-member-card" :class="member.cardClass" @click="navigate(member)">
        <h3>{{ member.name }}</h3>
      </div>
    </slide>
  </carousel>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
import Simulation from '../services/SimulationService';

export default {
  name: 'CommunityMemberPicker',
  data() {
    return {
      members: [],
    };
  },
  components: {
    Carousel,
    Slide
  },
  mounted(){
    this.members = Simulation.getMembers();
  },
  methods: {
    navigate(member){
      this.$router.push({ name: 'SimulationQuiz', params: { slug: member.slug } })
    }
  }
}
</script>
